import { render, staticRenderFns } from "./ChatExpertCard.vue?vue&type=template&id=1b0965fe&scoped=true"
import script from "./ChatExpertCard.vue?vue&type=script&lang=js"
export * from "./ChatExpertCard.vue?vue&type=script&lang=js"
import style0 from "./ChatExpertCard.vue?vue&type=style&index=0&id=1b0965fe&prod&scoped=true&lang=scss"
import style1 from "./ChatExpertCard.vue?vue&type=style&index=1&id=1b0965fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0965fe",
  null
  
)

export default component.exports